import { useFilterDataHook } from '@op/components/FilterCommon';
import { DBO_TM } from '@op/utils/format';
import { useBtnFilter } from '../../../../hook';
import { KeywordUrlTabType } from '@op/pages/AIAnalysisHub/KeywordAndURLAnalysis/types';

const defaultTime = DBO_TM.utcFilterRangeDay(90, 0);

interface UseFilterConfigProps {
  gameInfo: any;
  tab: KeywordUrlTabType;
  grammarTrue: boolean;
  urlDisabled?: boolean;
  hasUrlList?: boolean;
  defaultUserSynchronousValue?: Record<string, any>; 
  hasPermission?:boolean;
}

/**
 * 提取筛选器配置相关的共同逻辑
 */
export function useFilterConfig({
  gameInfo,
  tab,
  grammarTrue,
  urlDisabled = false,
  hasUrlList = true,
  defaultUserSynchronousValue,
  hasPermission = false, 
}: UseFilterConfigProps) {
  // FilterDataHook
  const {
    scrollBody,
    loading: filterLoading,
    changeFilter,
    filterOptions,
    confirmRef,
    filterReset,
    filterSave,
    filterConfirm,
    userSynchronousValue,
    changeUserSynchronousValue,
  } = useFilterDataHook({
    gameInfo,
    pageName: 'Summary_Keywords_Drill',
    defaultUserSynchronousValue,
  });

  // 按钮筛选器
  const {
    confirmDisabled,
    saveDisabled,
    setSaveDisabled,
    isGenerated,
    setDisabled,
    maximumDuration,
  } = useBtnFilter({ tab, grammarTrue, urlDisabled, hasUrlList, hasPermission });

  return {
    userSynchronousValue,
    changeUserSynchronousValue,
    // FilterDataHook 相关
    scrollBody,
    filterLoading,
    changeFilter,
    filterOptions,
    confirmRef,
    filterReset,
    filterSave,
    filterConfirm,

    // 按钮状态
    confirmDisabled,
    saveDisabled,
    setSaveDisabled,
    isGenerated,
    setDisabled,
    maximumDuration,

    // 默认时间
    defaultTime,
  };
}
